import Router from "../router"; 

let toSong = function (song, section = null) {

	let params = {
		song: song,
		section: "tree"
	};

	if (section != null) {
		params.section = section;
	}

	Router.push({
		name: "song",
		params: params
	});
};

let toArtist = function (artist, section = null) {

	let params = {
		artist: artist,
		section: "chronology"
	};

	if (section != null) {
		params.section = section;
	}

	Router.push({
		name: "artist",
		params: params
	});
};

export { toSong, toArtist };
